<template>
  <div class="container mx-auto p-4">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="3" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-store"></i>&nbsp;Stock</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CSelect
                  label="Sedes"
                  :options="data_campus"
                  placeholder="--Seleccione una sede --"
                  :value.sync="selectedCampus"
                  @change="onCampusChange"
                  :disabled="cpDisabledCampu"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="9" xl="9">
        <CTableWrapper
          :items="filteredProducts"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Productos"
          icon="fas fa-box"
          @mtdBack="returnHome"
          v-if="$store.getters.get_rol.id == 4"
        />
        <CTableWrapper
          :items="filteredProductsVen"
          :fields="fieldsVen"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Productos"
          icon="fas fa-box"
          @mtdBack="returnHome"
          v-else
        />
      </CCol>
    </CRow>
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu", label: "Sede", _style: "width:20%;" },
  { key: "almacen", label: "Almacen", _style: "width:20%;" },
  { key: "label", label: "Nombre", _style: "width:20%;" },
  { key: "stock", label: "Stock", _style: "width:20%;" },
  { key: "stock_min", label: "Stock Min", _style: "width:20%;" },
  { key: "label_unit", label: "Unidad", _style: "width:20%;" },
  { key: "cost", label: "Prec. Compra", _style: "width:20%;" },
  { key: "price", label: "Prec. Venta", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:20%;" },
];
const fieldsVen = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu", label: "Sede", _style: "width:20%;" },
  { key: "almacen", label: "Almacen", _style: "width:20%;" },
  { key: "label", label: "Nombre", _style: "width:20%;" },
  { key: "stock", label: "Stock", _style: "width:20%;" },
  { key: "stock_min", label: "Stock Min", _style: "width:20%;" },
  { key: "label_unit", label: "Unidad", _style: "width:20%;" },
  { key: "price", label: "Prec. Venta", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:20%;" },
];
import { mapActions } from "vuex";
import CTableWrapper from "@/components/shared/datatable/Table.vue";
export default {
  name: "stock",
  components: { CTableWrapper },
  data() {
    return {
      fields,
      fieldsVen,
      rol_id: this.$store.getters.get_rol.id,
      data_campus: [],
      data_product: [],
      data_product_ven: [],
      searchQuery: "", // Para la búsqueda
      selectedCampus: null,
    };
  },
  computed: {
    filteredProducts() {
      return this.data_product.filter((item) => {
        const search = this.searchQuery.toLowerCase();
        return (
          item.label.toLowerCase().includes(search) ||
          item.label_unit.toLowerCase().includes(search) ||
          item.price.toString().includes(search)
        );
      });
    },
    filteredProductsVen() {
      return this.data_product_ven.filter((item) => {
        const search = this.searchQuery.toLowerCase();
        return (
          item.label.toLowerCase().includes(search) ||
          item.label_unit.toLowerCase().includes(search) ||
          item.price.toString().includes(search)
        );
      });
    },
    cpDisabledCampu() {
      if (this.rol_id == 4 || this.rol_id == 8) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {},
  created() {
    // this.showProduct();
    this.getCampus();
    this.setDefaultCampus();
    // this.onCampusChange();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/getCampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus = [
            { label: "Todos", value: null },
            ...response.data.map((element) => ({
              label: element.name,
              value: element.id,
            })),
          ];
        }
      });
    },
    setDefaultCampus() {
      if (this.rol_id == 4) {
        this.selectedCampus = null; // "Todos"
        this.onCampusChange();
      } else {
        this.selectedCampus = this.$store.getters.get_campu.id;
        this.onCampusChange();
      }
    },
    onCampusChange() {
      if (this.selectedCampus == null) {
        this.showProduct();
      } else {
        this.showProduct(this.selectedCampus);
      }
    },
    showProduct(campuId = null) {
      let url =
        this.$store.getters.get__url +
        "/stock/byProduct/" +
        this.$store.getters.get_company.id;
      if (campuId != null) {
        url += "/" + campuId;
      }
      this.get({
        url: url,
        token: this.$store.getters.get__token,
      }).then((response) => {
        console.log(response.data.data);

        this.data_product = [];
        this.data_product_ven = [];
        let index = 1;
        let arrData = this.$store.getters.get_company.id == 5? Object.values(response.data.data): response.data.data;
        arrData.forEach((arr) => {
          const { stock, product_unit, production, almacen, is_production } =
            arr;

          let itemData;

          if (is_production) {
            // Manejo para producciones
            itemData = {
              label: production.name,
              value: production.id,
              price: production.price,
              cost: production.price, // o el costo que corresponda
              value_unit: null, // o el ID de unidad por defecto
              label_unit: "UND", // o la unidad que corresponda
              stock: parseInt(stock),
              stock_min: 0,
              index: index++,
              campu: almacen.campu.name,
              almacen: almacen.name,
              status: this.getStockStatus(stock, 0),
              is_production: true,
            };
          } else {
            // Manejo para productos normales
            const stock_min = product_unit.product.stock_min
              ? product_unit.product.stock_min
              : 0;
            itemData = {
              label: product_unit.product.name,
              value: product_unit.product.id,
              price: product_unit.product.price[0].sale_price,
              cost: product_unit.product.price[0].purchase_price,
              value_unit: product_unit.unit.id,
              label_unit: product_unit.unit.name,
              stock: parseInt(stock),
              stock_min: stock_min,
              index: index++,
              campu: almacen.campu.name,
              almacen: almacen.name,
              status: this.getStockStatus(stock, stock_min),
              is_production: false,
            };
          }

          if (this.$store.getters.get_rol.id == 4) {
            this.data_product.push(itemData);
          } else {
            this.data_product_ven.push(itemData);
          }
        });
      });
    },
    getStockStatus(stock, stock_min) {
      if (stock == 0) {
        return "Agotado";
      } else if (stock <= stock_min) {
        return "Existencias bajas";
      } else if (stock < 0) {
        return "Por reponer";
      } else {
        return "Stock disponible";
      }
    },
  },
};
</script>
<style scoped>
.equal-height-header {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 300px) {
  /* sm */
  .equal-height-header {
    min-height: 20px;
  }
}

@media (min-width: 576px) {
  /* sm */
  .equal-height-header {
    min-height: 20px;
  }
}

@media (min-width: 768px) {
  /* md */
  .equal-height-header {
    min-height: 80px;
  }
}
</style>
